import { constant, isNullish, map, pipe, when } from 'remeda';
import { type Descendant } from 'slate';

import { type UnityState } from '@@editor/typings/UnityElements';

import { type Next } from '../../types';
import wrapSerializedState from '../../wrapSerializedState';

const serializeCaption = (next: Next<UnityState>) => (caption?: Descendant[]) =>
    pipe(caption, when(isNullish, constant([])), map(next), wrapSerializedState);

export default serializeCaption;
